import moment from "moment"

// The live the student leaves may be missing from their courses (catch-up, temporary seat,
// support): then there is no start to count from and no tutor to name, and leaving must still work.

// A satisfaction rating is asked for once the session has run 15 minutes
export const shouldAskSatisfactionOnLeave = (liveMoment, now = moment()) =>
    !!liveMoment && now.isSameOrAfter(liveMoment.clone().add(15, "minutes"))

export const satisfactionDialogTitle = (liveSession) =>
    `Qu’as-tu pensé de cette session LIVE avec ${liveSession?.tutor?.display_name ?? "ton masteur"}`
